import styled from '@emotion/styled'

export const BusinessInTheMetaverseContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 85vh;
  display: flex;
  justify-content: center;
  color: #ffffff;

  @media (max-width: 1000px) {
    height: 50vh;
  }

  @media (max-width: 800px) {
    height: 40vh;
  }
`

export const BusinessInTheMetaverseContents = styled.div`
  position: relative;
  height: 100%;
  width: 85%;
  display: flex;
  overflow: hidden;
  video {
    min-width: 1600px;
    flex-grow: 1;
    border: none;
    margin: 0;
    padding: 0;
    object-fit: cover;
  }

  @media (max-width: 1800px) {
    video {
      min-width: 1800px;
      margin-left: -150px;
    }
  }

  @media (max-width: 1400px) {
    video {
      min-width: 1400px;
    }
  }

  @media (max-width: 1200px) {
    video {
      min-width: 1200px;
    }
  }

  @media (max-width: 1100px) {
    video {
      min-width: 1100px;
    }
  }

  @media (max-width: 1000px) {
    video {
      min-width: 1000px;
    }
  }

  @media (max-width: 800px) {
    video {
      min-width: 800px;
    }
  }

  @media (max-width: 700px) {
    video {
      min-width: 700px;
    }
  }

  @media (max-width: 600px) {
    video {
      min-width: 600px;
      margin-left: -100px;
    }
  }

  @media (max-width: 500px) {
    video {
      min-width: 500px;
      margin-left: -50px;
    }
  }

  @media (max-width: 400px) {
    video {
      min-width: 400px;
    }
  }
`

export const GifOverlay = styled.div`
  position: absolute;
  background-color: rgb(110, 108, 103, 0.3);
  width: 300px;
  bottom: 50px;
  left: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  a {
    color: #fd7603;
  }

  @media (max-width: 1000px) {
    bottom: 0px;
    left: 10px;
  }

  @media (max-width: 400px) {
    font-size: 0.75em;
    width: 200px;
  }
`

export const OurSuiteSweetContainer = styled.div`
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 50px;
`

export const OurSuiteSweetContents = styled.div`
  position: relative;
  width: 85%;

  h3 {
    font-weight: normal;
    margin-bottom: 30px;
  }
`
export const ProductsFlexContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`

export const ProductContainer = styled.div`
  width: 33%;
  img {
    max-width: 100%;
  }

  .product-description {
    margin-top: -30px;
    h3 {
      font-size: 1.5em;
    }
  }

  @media (max-width: 700px) {
    width: 100%;
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap-reverse;
  }
`

export const AcceleratedLearningContainer = styled.div`
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 50px;
`

export const AcceleratedLearningContents = styled.div`
  position: relative;
  width: 85%;

  h1 {
    margin-bottom: 30px;
  }
`

export const AcceleratedLearningFlexContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
`

export const AcceleratedLearningFlexItem = styled.div`
  width: 45%;
  .accelerated-learning-description {
    text-align: left;
    h4 {
      margin-top: 15px;
      font-size: 1em;
    }
    p {
      font-size: 0.8em;
    }
  }
  img {
    flex-grow: 1;
    max-height: 100%;
    max-width: 100%;
  }
  .see-how-your-course-works {
    margin-top: 15px;
    text-align: center;
    text-decoration: underline;
  }

  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const CEOTestimonialContainer = styled.div`
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 50px;
`

export const CEOTestimonialContents = styled.div`
  position: relative;
  width: 85%;
  img {
    max-width: 100%;
  }
`

export const CEOTestimonialOverlay = styled.div`
  position: absolute;
  padding: 15px;
  background-color: rgb(224, 109, 107, 0.7);
  color: #ffffff;
  width: 450px;
  top: 50px;
  left: 110px;
  text-align: left;
  font-size: 1.25em;

  @media (min-width: 1900px) {
    bottom: 40px;
    left: 50%;
    transform: translate(-50%, -50%);
    top: inherit;
  }

  @media (max-width: 1100px) {
    left: 50px;
  }

  @media (max-width: 1000px) {
    width: 300px;
    font-size: 1em;
  }

  @media (max-width: 800px) {
    font-size: 0.8em;
  }

  @media (max-width: 700px) {
    width: 250px;
    font-size: 0.75em;
  }

  @media (max-width: 600px) {
    left: 25px;
    top: 25px;
    font-size: 0.65em;
  }

  @media (max-width: 500px) {
    width: 200px;
    font-size: 0.6em;
  }

  @media (max-width: 430px) {
    left: 10px;
    top: 10px;
  }

  @media (max-width: 400px) {
    font-size: 0.5em;
    width: 175px;
  }
`

export const MasteryWithMethodologyContainer = styled.div`
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 50px;
`

export const MasteryWithMethodologyContents = styled.div`
  position: relative;
  width: 85%;

  h3 {
    font-weight: normal;
    margin-bottom: 30px;
  }
`

export const MasteryWithMethodologyImgContainer = styled.div`
  position: relative;
  img {
    max-height: 100%;
    max-width: 100%;
  }
`

export const MasteryWithMethodologyImgOverlay = styled.div`
  position: absolute;
  padding: 10px 15px;
  background-color: rgb(110, 108, 103, 0.3);
  color: #ffffff;
  width: 550px;
  bottom: 40px;
  left: 40px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 1.5em;

  @media (min-width: 1900px) {
    bottom: 40px;
    left: 50%;
    transform: translate(-50%, -50%);
    top: inherit;
  }

  @media (max-width: 1100px) {
    left: 50px;
  }

  @media (max-width: 1000px) {
    width: 300px;
    font-size: 1em;
  }

  @media (max-width: 850px) {
    font-size: 0.8em;
  }

  @media (max-width: 700px) {
    font-size: 0.75em;
    bottom: 10px;
    left: 10px;
  }

  @media (max-width: 600px) {
    left: 25px;
    top: 25px;
    font-size: 0.65em;
  }

  @media (max-width: 500px) {
    font-size: 0.5em;
  }

  @media (max-width: 430px) {
    left: 5px;
    top: 5px;
  }

  @media (max-width: 400px) {
  }
`

export const WhitePaperButton = styled.div`
  background-color: #fd7603;
  padding: 10px 35px;
  cursor: pointer;
  margin: 10px 0px;
  color: #ffffff;
  border-radius: 2px;
`

export const ItAllAddsUpContainer = styled.div`
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 50px;
`

export const ItAllAddsUpContents = styled.div`
  position: relative;
  width: 85%;

  h3 {
    font-weight: normal;
    margin-bottom: 30px;
  }
`

export const ItAllAddsUpCardPairContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  @media (max-width: 700px) {
  }
`

export const ItAllAddsUpCard = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .card-text-contents {
    width: 50%;
  }

  .card-text-contents p {
    color: #878787;
  }

  a {
    text-decoration: underline;
  }
  @media (max-width: 700px) {
    width: 100%;
    margin-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid black;
  }
`
export const OurPartnersContainer = styled.div`
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 50px;
`

export const OurPartnersContents = styled.div`
  position: relative;
  width: 85%;

  h3 {
    font-weight: normal;
    margin-bottom: 30px;
  }
`

export const OurPartnersFlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 20%;
    margin: 0px 10px;
  }
`

export const TheFinalWordContainer = styled.div`
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 50px;
`

export const TheFinalWordContents = styled.div`
  position: relative;
  width: 85%;

  h1 {
    margin-bottom: 30px;
  }
`

export const TheFinalWordImgContainer = styled.div`
  position: relative;
  img {
    max-height: 100%;
    max-width: 100%;
  }
`

export const TheFinalWordImgOverlay = styled.div`
  position: absolute;
  padding: 10px 15px;
  background-color: rgb(110, 108, 103, 0.6);
  color: #ffffff;
  font-size: 1.25em;
  width: 500px;
  bottom: 40px;
  right: 40px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 1900px) {
    bottom: 40px;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media (max-width: 700px) {
    width: 400px;
  }

  @media (max-width: 700px) {
    font-size: 0.85em;
    width: 300px;
  }

  @media (max-width: 450px) {
    font-size: 0.75em;
    width: 250px;
  }
`
